import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';

import { PropsWithClassname } from '@/app/types';

import CrossIcon from '@/app/components/CrossIcon/CrossIcon';
import LanguageSwitch from '@/app/components/LanguageSwitch/LanguageSwitch';

interface FormCardProps extends PropsWithChildren<PropsWithClassname> {
  onCloseButtonClick?: () => void;
}

const FormCard: FunctionComponent<FormCardProps> = ({ onCloseButtonClick, className, children }) => {
  const isCloseButtonVisible = !!onCloseButtonClick;

  const isFormHeaderVisible = isCloseButtonVisible;

  return (
    <div
      className={classNames(
        className,
        'max-w-[600px] mx-auto md:mt-[40px]  bg-white border border-neutral-light shadow-md',
      )}
    >
      {isFormHeaderVisible && (
        <div
          className={classNames('h-[80px] pl-[24px] pr-[10px] pb-[16px] mb-[16px] flex items-center', {
            'justify-between': isCloseButtonVisible,
          })}
        >
          <LanguageSwitch />
          {isCloseButtonVisible && (
            <button
              className="flex justify-center items-center w-[48px] h-[48px] border rounded-full border-transparent bg-transparent transition-colors hover:bg-secondary-light hover:border-primary-light"
              onClick={onCloseButtonClick}
            >
              <CrossIcon className="scale-[75%]" />
            </button>
          )}
        </div>
      )}
      <div className="px-[24px] max-w-[448px] mx-auto">{children}</div>
    </div>
  );
};

export default FormCard;
